module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    attrs: {
      "value": _vm.value,
      "activator": _vm.activator,
      "offset-y": "",
      "content-class": "playlists"
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, 'v-menu', _vm.$attrs, false), [_c('v-list', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-list-tile', [_vm._v("Add to")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, _vm._l((_vm.playlists), function(playlist) {
    return _c('playlist', {
      key: playlist.id,
      staticClass: "mb-2 mx-3",
      attrs: {
        "playlist": playlist,
        "audio-id": _vm.audio.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.playlists.length) ? _c('v-divider', {
    staticClass: "mb-2"
  }) : _vm._e(), _vm._v(" "), (!_vm.creatingPlaylist) ? _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.creatingPlaylist = true
      }
    }
  }, [_c('v-layout', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "d-flex": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n                Create new playlist\n            ")], 1)], 1) : [_c('v-list-tile', [_c('v-text-field', {
    attrs: {
      "label": "Title",
      "id": "title",
      "name": "title",
      "required": "",
      "rules": [function () { return !!_vm.form.title || 'This field is required'; }],
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('v-list-tile', [_c('v-select', {
    attrs: {
      "label": "Visibility",
      "items": ['private', 'secret', 'public']
    },
    model: {
      value: (_vm.form.visibility),
      callback: function($$v) {
        _vm.$set(_vm.form, "visibility", $$v)
      },
      expression: "form.visibility"
    }
  })], 1), _vm._v(" "), _c('v-list-tile', [_c('v-spacer'), _vm._v(" "), _c('app-btn', {
    ref: "btnSubmit",
    staticClass: "right",
    attrs: {
      "flat": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("\n                    Create\n                ")])], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794961f5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuAddToPlaylist.vue
// module id = 385
// module chunks = 0